module.exports = __webpack_public_path__ + "static/media/Dysrhythmia_Question3.699b45ee.jpg";